import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadWorkspaceHistory } from 'store/actions/admin/workspacesActions';

import Changelog from 'app/components/organisms/Changelog/Changelog';

class WorkspaceHistoryTab extends PureComponent {
    static propTypes = {
        id: PropTypes.string,
        isLoading: PropTypes.bool,
        records: PropTypes.arrayOf(PropTypes.object),
        startIndex: PropTypes.number,
        totalRecords: PropTypes.number,
    };

    loadData = ({ id, ...options }) => {
        return this.props.loadWorkspaceHistory(id, options);
    };

    render() {
        const { id, isLoading, records, startIndex, totalRecords } = this.props;
        return (
            <Changelog
                type="workspace"
                id={id}
                isLoading={isLoading}
                startIndex={startIndex}
                records={records}
                loadData={this.loadData}
                totalRecords={totalRecords}
            />
        );
    }
}

export default connect(
    state => ({
        records: state.admin.workspaces.history.records,
        totalRecords: state.admin.workspaces.history.count,
        isLoading: state.admin.workspaces.history.isLoading,
        startIndex: state.admin.workspaces.history.startIndex,
    }),
    { loadWorkspaceHistory }
)(WorkspaceHistoryTab);
